var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLockOpened(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.25 8.5V9.75469C9.38383 8.96381 10.7628 8.5 12.25 8.5C16.116 8.5 19.25 11.634 19.25 15.5C19.25 19.366 16.116 22.5 12.25 22.5C8.38401 22.5 5.25 19.366 5.25 15.5C5.25 14.1803 5.61518 12.946 6.25 11.8924V8.5C6.25 5.18629 8.93629 2.5 12.25 2.5C15.5637 2.5 18.25 5 18.25 7.5C18.25 8.05228 17.8023 8.5 17.25 8.5C16.6977 8.5 16.25 8.05228 16.25 7.5C16.25 6 14.4591 4.5 12.25 4.5C10.0409 4.5 8.25 6.29086 8.25 8.5ZM8.25 12.5H8.24963C7.62194 13.3357 7.25 14.3744 7.25 15.5C7.25 18.2614 9.48858 20.5 12.25 20.5C15.0114 20.5 17.25 18.2614 17.25 15.5C17.25 12.7386 15.0114 10.5 12.25 10.5C10.6144 10.5 9.16223 11.2853 8.25 12.4995V12.5ZM14.25 15.5C14.25 14.3954 13.3546 13.5 12.25 13.5C11.1454 13.5 10.25 14.3954 10.25 15.5C10.25 16.6046 11.1454 17.5 12.25 17.5C13.3546 17.5 14.25 16.6046 14.25 15.5Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockOpened);
export default __webpack_public_path__ + "static/media/lock_opened.18be099c8300d98bf601cd18decec61e.svg";
export { ForwardRef as ReactComponent };